import { isNil } from 'lodash';
import { Bert } from 'meteor/themeteorchef:bert';
import turf from '@turf/turf';

import {
  saveChangesInRPAPath,
  setTakeOffPoint,
  setLandingPoint
} from '../../api/Missions/mission-methods-client';
import { getWaypointList, getDesiredHeight } from '../../api/Missions/mission-operations';

import handleErrorInClient from '../handle-error-in-client';
import {
  getOperationType,
  insertNewWaypointsAtIndex,
  removeWaypoint,
  moveWaypoint,
  setWaypointNumbers,
  getDistanceTraveled,
  getWaypointType
} from '../waypoint-utilities';

/**
 * Function that takes in the edited waypoint list from the event fired and updates the mission in the database.
 *
 * @callback
 * @async
 * @param {*} arg - The object argument.
 * @param {object} arg.event - The event fired after editing the waypoint list.
 * @param {Function} arg.getCurrentMapState - A function that gets the current variables needed from the map component.
 */
const editWaypointsWorkflow = async ({ event, getCurrentMapState }) => {
  try {
    const {
      mission,
      startElevationProgressBar,
      cancelElevationProgress,
      geoJSONRpaPathLayer,
      geoJSONWaypointListLayer
    } = getCurrentMapState();
    const currentWaypointList = getWaypointList(mission);
    const newRPAPathLatLngs = event.poly.getLatLngs();
    const rpaOldPath = event.poly.feature;
    let newWaypointList = {};
    const operationType = getOperationType(rpaOldPath, newRPAPathLatLngs);
    let wptype = 5;
    let WPHeight = getDesiredHeight(mission);
    if (isNil(WPHeight)) throw new Error('Mission Height not defined');

    if (operationType.operation === 'move') {
      wptype = getWaypointType(currentWaypointList.features[operationType.index]);
      if (wptype === 1) WPHeight = 50;
      else if (wptype === 2) WPHeight = 0;
    }
    const nextWPFeature = turf.point([operationType.lon, operationType.lat], {
      type: wptype,
      altRelative: WPHeight,
      altAbsolute: WPHeight,
      altGround: 0
    });
    switch (operationType.operation) {
      case 'add':
        newWaypointList = insertNewWaypointsAtIndex(
          currentWaypointList,
          operationType.index,
          nextWPFeature
        );
        break;
      case 'delete':
        newWaypointList = removeWaypoint(currentWaypointList, operationType.index);
        break;
      case 'move':
        newWaypointList = moveWaypoint(currentWaypointList, operationType.index, nextWPFeature);
        break;
      default:
        newWaypointList = currentWaypointList;
        Bert.alert('You should not get themeteorchef', 'danger');
    }
    const newWaypointListWithNumbers = setWaypointNumbers(newWaypointList);
    geoJSONRpaPathLayer.clearLayers();
    geoJSONWaypointListLayer.clearLayers();
    const estimatedNumberOfPoints = getDistanceTraveled(newWaypointListWithNumbers) / 30;
    startElevationProgressBar(estimatedNumberOfPoints);
    try {
      await saveChangesInRPAPath(mission, newWaypointListWithNumbers);
      if (wptype === 1) setTakeOffPoint(mission._id, nextWPFeature);
      else if (wptype === 2) setLandingPoint(mission._id, nextWPFeature);
    } catch (error) {
      cancelElevationProgress();
      handleErrorInClient(error);
    }
  } catch (error) {
    handleErrorInClient(error);
  }
};

export default editWaypointsWorkflow;
